/*
 * Decimal, Account Management App.
 * Copyright (C) 2008-2013 Decimal
 * mailto:contact AT decimal DOT co DOT in
 *
 * Account is Decimal software; you can not redistribute it.
 * any versions of the License.
 * License is private by the Decimal Foundation;
 *
 * Inc., 8th Floor, Tower – D, Pioneer Urban Square, Golf Course Ext Rd,
 * Sector 62, Gurugram, Haryana 122102
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { environment } from '../../../environments/environment';
import { catchError } from 'rxjs/operators';
import { UtilityService } from '../services/utility.service';

const FOUROFOUR = 404;
const FOUROO = 400;
const FOUROONE = 401;
const FOUROTHREE = 403;
const FIVEOO = 500;
const OK = 200;
const ZERO = 0;

/**
 * This class will communicate with server via three method only
 * @method get
 * @method post
 * @method put
 * @method errorHandler will catch error and take action only on generic errors
 * @usageNotes
 *
 * To use this service inject this service in the constructor of other
 * service
 */
@Injectable({
  providedIn: 'root'
})
export class ApiService {
  apiSubjectData: Subject<Object> = new BehaviorSubject<Object>(null);

  constructor(
    private readonly http: HttpClient,
    private readonly us: UtilityService
  ) { }

  setApiSubjectData(data) {
    this.apiSubjectData.next(data);
  }

  /**
   * This method will call server via http get and return response
   * by casting it into custom interface
   *
   * @param options  is an optional parameter of type object that contain
   *  1. headers:HttpHeaders
   *  2. reportProgress = true/false
   ** @returns this method will return type I of interface
   */
  get<I>(endpoint, options?): Observable<I> {
    options['withCredentials'] = true;
    options['crossDomain'] = true;
    return this.http
      .get<I>(endpoint ? endpoint : environment.endPoint, options)
      .pipe(catchError(error => this.errorHandler(error)));
  }

  /**
   * This method will call server via http post and return response
   * by casting it into custom interface
   *
   * @param options  is an optional parameter of type object that contain
   *  1. headers:HttpHeaders
   *  2. reportProgress = true/false
   * @param body is an optional parameter of type object
   * @returns this method will return type I of interface
   */
  post<I>(endPoint, body, options?): Observable<I> {
    options['withCredentials'] = true;
    options['crossDomain'] = true;
    return this.http
      .post<I>(endPoint ? endPoint : environment.endPoint, body, options)
      .pipe(catchError(error => this.errorHandler(error)));
  }

  /**
   * This method will call server via http post and return response
   * by casting it into custom interface
   *
   * @param options  is an optional parameter of type object that contain
   *  1. headers:HttpHeaders
   *  2. reportProgress = true/false
   * @param body is an optional parameter of type object
   * @returns this method will return type I of interface
   */
  put<I>(endPoint, body, options?): Observable<I> {
    options['withCredentials'] = true;
    options['crossDomain'] = true;
    return this.http
      .put<I>(endPoint ? endPoint : environment.endPoint, body, options)
      .pipe(catchError(error => this.errorHandler(error)));
  }

  delete<I>(endPoint, options?): Observable<I> {
    options = options || {};
    options['withCredentials'] = true;
    options['crossDomain'] = true;
    return this.http
      .delete<I>(endPoint ? endPoint : environment.endPoint, options)
      .pipe(catchError(error => this.errorHandler(error)));
  }

  /**
   * This method will handle generic error take necessary action
   * @param response Error response from server
   */

    deleteAllCookies() {
    document.cookie.split(';').forEach(cookie => {
        const eqPos = cookie.indexOf('=');
        const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
    });
}
  errorHandler(response) {
    switch (response.status) {
      case ZERO: {
        this.us.openSnackBar('Possibly! Your internet is down or Server is not responding.');
        return of(null);
      }
      case FOUROONE: {
        if (response.error.code !== 'auth-001') {
          this.us.setCookie("ILG","");
          this.us.setCookie("ISLOGGEDIN","false");
          /// this.deleteAllCookies();
          window.open(environment.signinUrl, '_self');
        }
        return of(response.error);
      }
      case FOUROTHREE: {
        if (response.error.code == 'auth-020') {
          this.setApiSubjectData({ action: 'selection', message: response.error.message });
        }
        return of(response.error);
      }
      default: {
        console.log(response)
        if (response.hasOwnProperty('error') && response.error) {
          let errorstatus = 500;
          let errorFourHundred = 400;
          if(response?.error?.status === errorstatus || response?.status === errorFourHundred) {
            return of(response.error);
          }
          this.us.openSnackBar(response.error.message);
          return of(response.error);
        }
      }
    }

    return of(response.error);
  }

}
